import { IconButton, IconButtonProps, SvgIcon, SvgIconProps } from "@mui/material";
import AppLink, { AppLinkProps } from "./AppLink/AppLink";
import { SvgIconComponent } from "@mui/icons-material";
import React from "react";
import _ from "lodash";

type IconButtonLinkProps = IconButtonProps & {
  to: string;
  Icon: typeof SvgIcon,
  linkProps?: Omit<AppLinkProps, 'to'>,
  iconProps?: SvgIconProps,
}

export default function IconButtonLink({ to, Icon, linkProps, iconProps }: IconButtonLinkProps) {
  const computedLinkProps: AppLinkProps = _.merge({ to, sx: { fontSize: '0px' } }, linkProps);
  const computedIconProps: SvgIconProps = _.merge({ sx: { color: "grey" } }, iconProps);

  return (
    <IconButton>
      <AppLink {...computedLinkProps}>
        <Icon {...computedIconProps} />
      </AppLink>
    </IconButton>
  );
}